import { createContext } from "react";
import { PositionsSort } from "@shared/features/portfolio/types.ts";
import { ConsolidatedCoinData, SortingOrder } from "@shared/types";

export const PositionsContext = createContext<
  | {
      sortBy: PositionsSort;
      setSortBy: (sortBy: PositionsSort) => void;
      sortDirection: SortingOrder;
      setSortDirection: (sortDirection: SortingOrder) => void;
      changeLeverageCoinData?: ConsolidatedCoinData;
      setChangeLeverageCoinData: (coinData?: ConsolidatedCoinData) => void;
    }
  | undefined
>(undefined);
